import React from "react";
import { Check } from "lucide-react";

/**
 * Section 04 — dark card listing privacy bullets. Each bullet has a green
 * check icon. Two-column layout on desktop, single column on mobile.
 */
const PrivateByDesign = ({ section, number = "04" }) => {
  if (!section) return null;
  const {
    title = "Private by design",
    description,
    bullets = [],
  } = section;

  if (bullets.length === 0 && !description) return null;

  return (
    <div className="corp-section-card corp-section-card--dark">
      <div className="flex items-center gap-3">
        <span className="corp-section-num corp-section-num--dark">{number}</span>
        <h2 className="corp-section-title">{title}</h2>
      </div>
      {description && <p className="corp-section-desc">{description}</p>}
      {bullets.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {bullets.map((bullet, idx) => (
            <div key={idx} className="flex items-center gap-2">
              <span className="corp-bullet-check">
                <Check size={12} strokeWidth={3} />
              </span>
              <span className="corp-bullet-text text-sm text-white">{bullet}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PrivateByDesign;
